import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "@/context/AuthContext";
import { AlertTriangle, Clock, Download, FileText, Flame, ShieldCheck } from "lucide-react";
import axios from "axios";

export default function PublicReport() {
  const { token } = useParams();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/public/reports/${token}/meta`);
        setMeta(data);
      } catch (err) {
        setError(err?.response?.data?.detail || "Bağlantı geçersiz");
      } finally { setLoading(false); }
    })();
  }, [token]);

  if (loading) return <div className="auth-splash"><Flame size={22}/><span>Rapor yükleniyor…</span></div>;
  if (error) {
    return (
      <div className="public-shell" data-testid="public-report-error">
        <div className="public-card error">
          <AlertTriangle size={28}/>
          <h2>Bağlantı kullanılamaz</h2>
          <p>{error}</p>
          <small>Rapor sahibi bağlantıyı yeniden üretebilir.</small>
        </div>
      </div>
    );
  }

  const expiresLocal = meta?.share?.expires_at ? new Date(meta.share.expires_at).toLocaleString("tr-TR") : "—";
  const pdfUrl = `${API}/public/reports/${token}`;

  return (
    <div className="public-shell" data-testid="public-report">
      <header className="public-head">
        <div><Flame size={18}/> HazmatCore · Taslak Rapor (Salt Okunur)</div>
        <small><ShieldCheck size={12}/> Mevzuat snapshot: {meta.report.legislation}</small>
      </header>
      <div className="public-body">
        <section className="public-meta">
          <h1>Rapor {meta.report.code}</h1>
          <small><Clock size={12}/> Son geçerlilik: {expiresLocal} · Erişim sayısı {meta.share.access_count}</small>
          <small>Oluşturan: {meta.share.created_by} · {(meta.report.created_at||"").slice(0,16).replace("T"," ")}</small>
          <div className="public-actions">
            <a className="primary-btn" href={pdfUrl} target="_blank" rel="noreferrer" data-testid="public-download">
              <Download size={14}/> PDF indir
            </a>
            <a className="secondary-btn" href={pdfUrl} target="_blank" rel="noreferrer" data-testid="public-view">
              <FileText size={14}/> Yeni sekmede aç
            </a>
          </div>
          <small className="legal-foot">Bu bağlantı yalnızca süreli görüntüleme amaçlıdır. Rapor sahibi tarafından iptal edilebilir ve resmi uygunluk kararı niteliği taşımaz.</small>
        </section>
        <section className="public-viewer">
          <iframe title="Rapor" src={pdfUrl} data-testid="public-iframe"/>
        </section>
      </div>
    </div>
  );
}
